import { requestFollowProduct } from "@/api/product";
import { useCommonContext } from "@/utils/context/common";
import EventManager from "@/utils/event/eventManager";
import { EventName, FollowStatusEventData } from "@/utils/event/events";
import useNavigation from "@/utils/useNavigate";
import { ProductDetailModel } from "@akc/biz-api";
import { Image, Toast } from "antd-mobile";
import React, { useEffect, useState } from "react";
import useCheckBind from "../../hook/useCheckBind";
import styles from "./index.module.less";

const eventManager = new EventManager();

type Props = {
  productDetail?: ProductDetailModel;
  showFavoriteIcon?: boolean;
};

const FollowProduct: React.FC<Props> = ({ productDetail, showFavoriteIcon }) => {
  const { userVisitInfo } = useCommonContext();
  const { toAuth } = useCheckBind();

  // 初始收藏状态
  const [isFollow, setIsFollow] = useState<boolean>(false);

  // 初始化时从商品详情获取收藏状态
  useEffect(() => {
    if (productDetail?.skuExtendInfoVO?.isFollow !== undefined) {
      setIsFollow(!!productDetail.skuExtendInfoVO.isFollow);
    }
  }, [productDetail?.skuExtendInfoVO?.isFollow, productDetail]);

  // 监听收藏状态变更事件，用于同步其他地方的收藏操作
  useEffect(() => {
    const handleFollowStatusChange = (data: FollowStatusEventData) => {
      // 确保是同一个商品
      if (data.spuId === productDetail?.activitySpuId) {
        setIsFollow(data.isFollow);
      }
    };

    // 订阅收藏状态变更事件
    eventManager.subscribe<FollowStatusEventData>(
      EventName.updateFollowStatus,
      handleFollowStatusChange,
    );

    // 组件卸载时取消订阅
    return () => {
      eventManager.unsubscribe(EventName.updateFollowStatus, handleFollowStatusChange);
    };
  }, [productDetail?.activitySpuId]);

  // 处理收藏/取消收藏操作
  const handleFollowClick = async () => {
    // 未登录则跳转到登录页
    if (!userVisitInfo?.isAuthorized) {
      toAuth();
      return;
    }

    if (!productDetail?.activitySpuId) {
      Toast.show("商品信息不完整");
      return;
    }

    try {
      // 调用收藏/取消收藏接口
      const result = await requestFollowProduct(!isFollow, productDetail?.spuInfoVO?.spuId || "");

      // 更新状态
      if (result) {
        const newFollowStatus = !isFollow;
        setIsFollow(newFollowStatus);
        localStorage.setItem(
          "notifyFollowProduct",
          JSON.stringify({
            isFollow: newFollowStatus,
            spuId: productDetail?.spuInfoVO?.spuId,
          }),
        );

        Toast.show(newFollowStatus ? "收藏成功" : "已取消收藏");
      }
    } catch (error) {
      Toast.show("操作失败，请稍后再试");
      console.error("收藏操作失败:", error);
    }
  };

  return (
    <div
      className={styles.followContainer + " " + (showFavoriteIcon ? styles.favorite : "")}
      onClick={handleFollowClick}>
      <Image
        className={styles.followIcon}
        src={
          isFollow
            ? "https://akim-oss.aikucun.com/b18bfaf7a8b3cb45b7b3c00c872811bda1d1079c_1753869751726_70.png"
            : "https://akim-oss.aikucun.com/a261b6b5b32cdf4d294ab1827f571a906b88a623_1753869846428_57.png"
        }
        alt={isFollow ? "已收藏" : "收藏"}
      />
    </div>
  );
};

export default FollowProduct;
